import React from 'react'
import { Box, Button, Divider, Grid } from '@mui/material'
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PropTypes from "prop-types";

const AddApplicantButton = ({ applicantNo, handleAddApplicant, totalApplicants,isOtherApplicant }) => { 
    const shouldShowButton = (totalApplicants && applicantNo === totalApplicants && totalApplicants < 4) || isOtherApplicant;
    
    return (
    <>
        {shouldShowButton && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Divider
                    sx={{
                        borderStyle: "dashed",
                        borderColor: "#D6D6D6",
                        borderWidth: "1px",
                        mb: 2,
                        mt: 1,
                    }}
                />
                <Box display="flex" justifyContent="center">
                    <Button
                        size="large"
                        variant="contained"
                        sx={{
                            backgroundColor: "#1A407D",
                            textTransform: "none",
                            borderRadius: "8px",
                            "&:hover": {
                                backgroundColor: "#092552"
                            }
                        }}
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={handleAddApplicant}
                    >
                        {`Add Applicant ${applicantNo + 1}`}
                    </Button>
                </Box>
            </Grid>
        )}
    </>
    )
}



AddApplicantButton.propTypes = {
  applicantNo: PropTypes.any,
  handleAddApplicant: PropTypes.any,
  isOtherApplicant: PropTypes.bool,
  totalApplicants: PropTypes.any,
};

export default AddApplicantButton